module.exports = __webpack_public_path__ + "static/blue-sun-b41141941da51654841bd61d2a62ce61.png";